@if (initialized && showNotifications && groupedNotifications) {

  <div class="surface-card border-round-lg">
    <div class="flex align-items-center justify-content-between p-4 pb-2">
      <div class="text-900 font-medium text-xl">Benachrichtigungen</div>
      <div>
        @if (newNotifications > 0) {
          <p-badge [value]="newNotifications+''"></p-badge>
        }
      </div>
    </div>
    <div class="h-28rem overflow-y-auto custom-scrollbar h-full p-4">
      @if (groupedNotifications && groupedNotifications.length) {

        @for (notificationGroup of groupedNotifications; track notificationGroup.action) {
          <span class="block text-600 font-light mb-4 uppercase">{{ notificationGroup.action | actionToText }}</span>
          <ul class="p-0 m-0 list-none">
            @for (notification of notificationGroup.notifications; track notification.id; let index = $index) {
              <li class="flex pl-2 pb-4 surface-border mt-3 mb-5 border-bottom-1"
                  (click)="navigateToTicket(notification)">

                @if (notification.newNotification) {
                  <div
                    class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0"
                    pBadge>
                    <p-avatar [image]="notification.imageUrl" styleClass="mr-2" size="xlarge" shape="circle"></p-avatar>
                  </div>
                } @else {
                  <div
                    class="w-3rem h-3rem flex align-items-center justify-content-center bg-blue-100 border-circle mr-3 flex-shrink-0">
                    <p-avatar [image]="notification.imageUrl" styleClass="mr-2" size="xlarge" shape="circle"></p-avatar>
                  </div>
                }

                <div
                  class="flex md:align-items-start md:justify-content-between flex-column md:flex-row gap-2 w-full cursor-pointer">
                  <div class="text-900 line-height-3 font-medium flex flex-column gap-2">
                    <span> {{ notification.subLabel }} </span>
<!--                    <p class="text-700 font-normal">{{ notification.text }}</p>-->

<!--                    <p-tag-->
<!--                      *ngIf="notification.ticketStatus"-->
<!--                      [icon]="notification.ticketStatusIcon"-->
<!--                      [value]="notification.ticketStatusLabel"-->
<!--                      [style]="notification.ticketStatusStyle"-->
<!--                      [rounded]="true"-->
<!--                      class="ml-2">-->
<!--                    </p-tag>-->

                    <p-tag
                      *ngIf="notification.ticketStatus"
                      icon="pi pi-circle-fill"
                      [value]="notification.ticketStatus"
                      [rounded]="true"
                      severity="info"
                      class="ml-2">
                    </p-tag>

                  </div>

                  <div class="text-700 font-light uppercase white-space-nowrap flex flex-column gap-2">
                    <span>{{ notification.mainLabel }}</span>
                    <span>{{ notification.createdOn | date:"dd.MM.YYYY" }}</span></div>
                </div>
              </li>
            }
          </ul>
        }
      } @else {
        <div class="flex flex-column gap-2 align-items-center my-5">
          <i class="pi pi-search text-8xl text-200"></i>
          <h4 class="">Hier siehst du deine Anfragen und Benachrichtigungen.</h4>
          <span class="text-color-secondary text-center">
            Derzeit gibt es keine offenen Vorgänge.
          </span>
        </div>
      }
    </div>
  </div>
}

